var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-elements"},[(_vm.poster)?_c('fcwpHomePoster',{attrs:{"poster":_vm.poster}}):_vm._e(),(_vm.menu)?_c('fcwpHomeMenu',{attrs:{"menu":_vm.menu}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }